import wheringFetch from "../../helpers/fetch";
import { WHERING_BASE_URL } from "./index";

const DEEPLINKS_BASE_PATH = "app/v1/deeplinks";

const deeplinksApi = {
  // Analytics endpoints
  getStats: async (path) => {
    const sanitizedPath = path.replace(/^\//, ''); // Remove leading slash
    return wheringFetch(WHERING_BASE_URL, `${DEEPLINKS_BASE_PATH}/stats/${sanitizedPath}`, "GET");
  },

  // All deeplinks endpoints
  getAllDeeplinks: async (limit = 10, page = 0, search = "") => {
    const params = new URLSearchParams({ limit, page });
    if (search) params.append("search", search);
    return wheringFetch(WHERING_BASE_URL, `${DEEPLINKS_BASE_PATH}?${params.toString()}`, "GET");
  },

  // Shortened URLs endpoints
  createShortUrl: async (url) => {
    return wheringFetch(WHERING_BASE_URL, `${DEEPLINKS_BASE_PATH}/shorten`, "POST", { url });
  },

  getShortenedUrls: async (limit = 10, offset = 0, search = "") => {
    const params = new URLSearchParams({ limit, offset });
    if (search) params.append("search", search);
    return wheringFetch(WHERING_BASE_URL, `${DEEPLINKS_BASE_PATH}/shortened-urls?${params.toString()}`, "GET");
  },

  deleteShortUrl: async (shortCode) => {
    return wheringFetch(WHERING_BASE_URL, `${DEEPLINKS_BASE_PATH}/shortened-urls/${shortCode}`, "DELETE");
  },

  // UTM Configuration endpoints
  createUtmConfig: async (path, config) => {
    return wheringFetch(WHERING_BASE_URL, `${DEEPLINKS_BASE_PATH}/${path}/utm-configs`, "POST", config);
  },

  getUtmConfigs: async (path) => {
    return wheringFetch(WHERING_BASE_URL, `${DEEPLINKS_BASE_PATH}/${path}/utm-configs`, "GET");
  },

  deleteUtmConfig: async (path, configId) => {
    return wheringFetch(WHERING_BASE_URL, `${DEEPLINKS_BASE_PATH}/${path}/utm-configs/${configId}`, "DELETE");
  },

  // Bulk UTM Configuration endpoint
  createBulkUtmConfig: async (config) => {
    return wheringFetch(WHERING_BASE_URL, `${DEEPLINKS_BASE_PATH}/utm-configs/bulk`, "POST", config);
  },

  // Bulk UTM Deletion endpoint
  deleteBulkUtmConfig: async (config) => {
    return wheringFetch(WHERING_BASE_URL, `${DEEPLINKS_BASE_PATH}/utm-configs/bulk`, "DELETE", config);
  },
};

export default deeplinksApi;
